import React from 'react'
import RModal from 'react-modal'
import s from './Modal.less'
import ClosePopinButton from './ClosePopinButton'
import { useAction } from '../utils/react-redux'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'
import { isGE } from '../Device'
import { navigateBack } from '../../store/history/history.actions'
import { appId } from '../../App'
import useModal from '../ui/useModal'
import useEventCallback from '../utils/useEventCallback'

const customStyle = {
  overlay: {
    zIndex: 180,
    backgroundColor: 'rgba(128, 128, 128, 0.55)'
  },
  content: {
    top: '50%',
    left: '50%',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    right: 'auto',
    bottom: 'auto',
    padding: 0,
    overflow: 'none',
    backgroundColor: 'white',
    borderRadius: '12px',
    border: '1px solid rgb(204, 204, 204)'
  }
}

const Modal = ({
  modalId,
  children,
  overlayStyle = {},
  style = {},
  withCloseButton,
  hasTag = true,
  shouldNavigateBackOnClose = false,
  onClose,
  ...rModalProps
}) => {
  const { hideModal, isModalDisplayed } = useModal(modalId)
  const execNavBack = useAction(navigateBack)
  RModal.setAppElement(`#${appId}`)

  const stopPropagationHandler = useEventCallback(() => {})

  const onRequestClose = useEventCallback(() => {
    if (onClose) {
      onClose()
    } else if (shouldNavigateBackOnClose) {
      execNavBack()
    } else {
      hideModal()
    }
  }, [shouldNavigateBackOnClose, hideModal])

  return (
    <span className={s.modalContainer} onClick={stopPropagationHandler}>
      <RModal
        style={{
          overlay: {
            ...customStyle.overlay,
            ...overlayStyle
          },
          content: {
            ...customStyle.content,
            ...style
          }
        }}
        shouldCloseOnOverlayClick={isGE()}
        onRequestClose={onRequestClose}
        isOpen={isModalDisplayed}
        {...rModalProps}
      >
        {withCloseButton && <ClosePopinButton className={s.closeButton} hasTag={hasTag} />}
        {children}
      </RModal>
    </span>
  )
}

// webpack:BrowserOnly
export default withEmptyFallbackErrorBoundary(Modal)
